import { create } from 'zustand';

/** UI state: the site currently selected in the top bar (null = all sites the user may see). */
export const useSiteScope = create<{ siteId: string | null; setSite(id: string | null): void }>((set) => ({
  siteId: null,
  setSite: (siteId) => set({ siteId }),
}));
